<template>
  <v-container>
    <v-row class="pb-4">
      <v-col>
        <v-icon> mdi-settings </v-icon>
        <span class="headline mx-2">User Access</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height"
      
      align="center" 
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>
    <template v-else>
      <v-row 
        v-if="edit" 
      >
        <v-col cols="12">
          <v-checkbox
            v-model="form.is_mobile_allowed"
          >
            <template v-slot:label>
              <div>
                Approval Mobile Access
              </div>
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="form.is_monitoring_allowed"
          >
            <template v-slot:label>
              <div>
                Approval Monitoring Access
              </div>
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="form.require_device_checking"
          >
            <template v-slot:label>
              <div>
                Require Device Checking
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <template v-else>
        <v-row>
          <v-col
            cols="12"
            md="5" 
            xl="4"
          >
            <span class="font-weight-medium">Approval Mobile Access: </span>
          </v-col>
          <v-col>
            <v-icon 
              v-if="user.is_mobile_allowed === 1" 
              color="success"
            >
              mdi-check-outline
            </v-icon>
            <v-icon 
              v-else 
              color="error"
            >
              mdi-close-outline
            </v-icon>        
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            md="5" 
            xl="4"
          >
            <span class="font-weight-medium mr-2">Approval Monitoring Access:</span>
          </v-col>
          <v-col>
            <v-icon 
              v-if="user.is_monitoring_allowed === 1" 
              color="success"
            >
              mdi-check-outline
            </v-icon>
            <v-icon 
              v-else 
              color="error"
            >
              mdi-close-outline
            </v-icon>        
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            md="5" 
            xl="4"
          >
            <span class="font-weight-medium">Require Device Checking:</span>
          </v-col>
          <v-col>
            <v-icon 
              v-if="user.require_device_checking === 1" 
              color="success"
            >
              mdi-check-outline
            </v-icon>
            <v-icon 
              v-else 
              color="error"
            >
              mdi-close-outline
            </v-icon>        
          </v-col>
        </v-row>
      </template>
    </template>
    <v-card-actions v-if="$hasPermissionTo(['update whole users'])">
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="info"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div>
    </v-card-actions>
  </v-container>
</template>

<script>
  export default {
    props: {
      userUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        edit: false,

        user: {},

        form: {
          is_mobile_allowed: null,
          is_monitoring_allowed: null,
          require_device_checking: null,
        },
      }
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUser()
          }
        },
      },
    },
    methods: {    
      submitForm () {
        this.progressing = true

        this.$api.users().update(this.userUid, this.prepareFormData())
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              Object.keys(this.form).map(key => {
                this.$set(this.user, key, this.form[key] ? 1 : 0)
              })

              this.edit = false

              this.$snack({
                message: response.data.status,
              })
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
      loadUser () {
        this.loading = true

        this.$api.users().show(this.userUid)
          .then(response => {
            this.user = response.data          
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      editForm () {
        Object.keys(this.form).map(key => {
          this.form[key] = this.user[key] === 1
        })

        this.edit = true
      },
      prepareFormData () {
        return {
          is_mobile_allowed: this.form.is_mobile_allowed ? 1 : 0,
          is_monitoring_allowed: this.form.is_monitoring_allowed ? 1 : 0,
          require_device_checking: this.form.require_device_checking ? 1 : 0,
        }
      },
    },
  }
</script>
